'use strict';

module.exports = {
  apiHost: 'https://virginia-dev-developer-api.august.com',
};
